export default "__VITE_ASSET__a1a51ef1__"